import React from 'react'
import { RouteChildrenProps } from 'react-router'
import { Location } from 'history'

import {
  Footer,
  IndexLayoutOldSubtitle,
  IndexLayoutOldTitle,
  routes,
} from '@sketch/modules-common'
import { LinkButton } from '@sketch/components'

import { PrivateWorkspaceRouteExtraProps } from '../../containers'

import {
  ActionWrapper,
  BackgroundImage,
  ContinueLink,
  FooterWrapper,
  StyledIndexLayout,
  TextWrapper,
} from './WorkspaceThankYou.styles'

import img from '@sketch/icons/workspace-thank-you.png'
import img2x from '@sketch/icons/workspace-thank-you@2x.png'

type PossibleRouteState = {
  redirectTo?: string
}

interface WorkspaceThankYouProps
  extends PrivateWorkspaceRouteExtraProps,
    RouteChildrenProps {}

export const WorkspaceThankYou = (props: WorkspaceThankYouProps) => {
  const { workspace, location: untypedLocation } = props
  const workspaceId = workspace.identifier

  const location = untypedLocation as Location<PossibleRouteState>

  return (
    <StyledIndexLayout
      headerLink="workspace-shares"
      showFooter={false}
      fullWidth
    >
      <TextWrapper>
        <IndexLayoutOldTitle>Thanks for trying Sketch</IndexLayoutOldTitle>
        <IndexLayoutOldSubtitle>
          The trial for your <b>“{workspace.name}”</b> Workspace has ended. To
          continue using Sketch, choose a subscription plan. We’ll have you set
          up and ready to do your best work in minutes.
        </IndexLayoutOldSubtitle>
        <ActionWrapper>
          <LinkButton
            variant="primary"
            size="32"
            to={routes.WORKSPACE_SUBSCRIBE.create({ workspaceId })}
          >
            Next: Choose a Plan
          </LinkButton>
          <ContinueLink
            size="smaller"
            to={
              location.state?.redirectTo ||
              routes.WORKSPACE_SHARES.create({ workspaceId })
            }
          >
            Continue to Workspace
          </ContinueLink>
        </ActionWrapper>
      </TextWrapper>
      <BackgroundImage
        srcSet={`${img} 1x, ${img2x} 2x`}
        alt="Sketch app screenshot"
      />
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </StyledIndexLayout>
  )
}
